<script>
import moment from 'moment'
import OrderedItem from './components/ordered-item.vue'
import PaymentDetail from './components/payment-detail.vue'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'saleInvoiceCreate',
  components: {
    OrderedItem,
    PaymentDetail
  },
  data() {
    return {
      errors: new Errors(),
      show_pdf: false,
      waiting: false,
      src: undefined,
      model: {
        current_date: moment().format('DD-MM-YYYY'),
        stock_out_date: moment().format('DD-MM-YYYY'),
        customer_id: null,
        sub_total: 0,
        discount: 0,
        input_discount: 0, // add new
        total_after_discount: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        amount_deposit: 0,
        amount_paid: 0,
        input_amount_paid: 0, // add new
        amount_due: 0,
        next_payment_date: '',
        remark: '',
        product_detail: [],
        quotation_id: undefined,
        contract_id: undefined,
        reference_no: null,
        seller_id: null,
        credit_day: 0,
        payment_method_id: 1,
        bank_name: null,
        bank_id: null,
        account_number: null,
        account_name: null,
        action_button: false,
        is_check_back_date: false,
        contact_number: '',
        fx_rate: 1,
        fx_rate_ratio: 1,
        input_currency_id: undefined,
        currency_id: undefined,
        paperSize: 'a5'
      }
    }
  },
  computed: {
    ...mapState('saleInvoiceStore', ['loading'])
  },
  async mounted() {
    await this.onGetCurrency().then(({ data }) => {
      const defaultCurrency = data.find(c => c.is_default)
      if (defaultCurrency) {
        this.model.currency_id = defaultCurrency.currency_id
        this.model.input_currency_id = defaultCurrency.currency_id
      }
    })
    await this.onGetPaymentMethod()
    await this.onGetCustomer()
  },
  methods: {
    ...mapActions('saleInvoiceStore', [
      'onGetCurrency',
      'onGetPaymentMethod',
      'onStore',
      'onGetCustomer'
    ]),
    onSave() {
      this.$store.commit('saleInvoiceStore/SET_LOADING', true)
      this.onStore(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'sale-invoice' })
        })
        .catch(({ response }) => {
          this.$toasted.error(response.data.message)
          this.errors = new Errors(response.data.errors)
        })
        .finally(() =>
          this.$store.commit('saleInvoiceStore/SET_LOADING', false)
        )
    },
    saveAddNew() {
      this.show_pdf = true
      this.waiting = true
      this.onStore(this.model)
        .then(response => {
          this.printPdf(response.data.stockOutId)
          this.clearInput()
        })
        .catch(({ response }) => {
          this.$toasted.error(response.data.message)
          this.errors = new Errors(response.data.errors)
          this.show_pdf = false
        })
        .finally(() =>
          this.$store.commit('saleInvoiceStore/SET_LOADING', false)
        )
    },
    printPdf(stockOutId) {
      this.$store
        .dispatch('saleInvoiceStore/onPreviewPdf',{
          id: stockOutId,
          paperSize: this.model.paperSize
        })
        .then(response => {
          this.src = response.data.url
        })
        .catch(response => {
          this.errors = new Errors(response.data.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.model.current_date = moment().format('DD-MM-YYYY')
      this.model.stock_out_date = moment().format('DD-MM-YYYY')
      this.model.customer_id = null
      this.model.sub_total = 0
      this.model.discount = 0
      this.model.input_discount = 0
      this.model.total_after_discount = 0
      this.model.vat_rate = 0
      this.model.vat_amount = 0
      this.model.grand_total = 0
      this.model.amount_deposit = 0
      this.model.amount_paid = 0
      this.model.input_amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = ''
      this.model.remark = ''
      this.model.product_detail = []
      this.model.quotation_id = undefined
      this.model.contract_id = undefined
      this.model.reference_no = null
      this.model.seller_id = null
      this.model.credit_day = 0
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.bank_id = null
      this.model.account_number = null
      this.model.account_name = null
      this.model.action_button = false
      this.model.is_check_back_date = false
      this.model.contact_number = ''
      this.model.fx_rate = 1
      this.model.fx_rate_ratio = 1
      this.model.input_currency_id = undefined
      this.model.currency_id = undefined
      this.model.paperSize = 'a5'
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleInvoice.pageTitle'),
            href: '/v2/admin/whole-sales'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <OrderedItem v-model="model" :validate="errors" />
          <div :class="{ 'ts-text-red-500': errors.has('product_detail') }">
            {{ errors.first('product_detail') }}
          </div>
        </ts-card-wrapper>
      </ts-card>
      <ts-card>
        <ts-card-wrapper>
          <PaymentDetail v-model="model" :validate="errors" />
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
            <ts-button
              :disabled="loading"
              @click.prevent="$router.push({ name: 'sale-invoice' })"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="saveAddNew"
              outline
              color="primary"
              >{{ $t('savePrint') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </ts-card-wrapper>
      </ts-card>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-loading-banner>
  </div>
</template>
